import { render, staticRenderFns } from "./PriceGroups.vue?vue&type=template&id=318f7820&"
import script from "./PriceGroups.vue?vue&type=script&lang=js&"
export * from "./PriceGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports